import { render, staticRenderFns } from "./BussinessOrder.vue?vue&type=template&id=0f6cb881&scoped=true&"
import script from "./BussinessOrder.vue?vue&type=script&lang=js&"
export * from "./BussinessOrder.vue?vue&type=script&lang=js&"
import style0 from "./BussinessOrder.vue?vue&type=style&index=0&id=0f6cb881&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6cb881",
  null
  
)

export default component.exports